module.exports = __webpack_public_path__ + "media/images/plans/online-wedding-spacemarket-image-b27b091a7083bad2457719fd85eb4e4a.png";